import { Store } from 'vuex'
import { emitter } from '@kwixeo/interface-vue'
import { fetchTask } from '../fetchDatas/task'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.TaskCategoryCreated',
    callback: (category: KwixeoTasks.Category): void => {
      store.dispatch('tasks/setCategory', category)
    }
  },
  {
    name: '.TaskCategoryUpdated',
    callback: (category: KwixeoTasks.Category): void => {
      store.dispatch('tasks/setCategory', category)
    }
  },
  {
    name: '.TaskCategoryDeleted',
    callback: (category: KwixeoTasks.Category): void => {
      store.dispatch('tasks/deleteCategory', category)
    }
  },

  {
    name: '.TaskCreated',
    callback: async (event: { id: number; updated_at: string }): Promise<void> => {
      const task = await fetchTask(event.id)
      emitter.emit('taskCreated', task)
    }
  },
  {
    name: '.TaskUpdated',
    callback: async (event: { id: number; updated_at: string }): Promise<void> => {
      const task = await fetchTask(event.id)
      emitter.emit('taskUpdated', { old: null, new: task })
    }
  },
  {
    name: '.TaskDeleted',
    callback: (event: { id: number; updated_at: string }): void => {
      emitter.emit('taskDeleted', event.id)
    }
  }
])
